import { render, staticRenderFns } from "./ClosestPopulationsResult.vue?vue&type=template&id=8476c15c&scoped=true"
import script from "./ClosestPopulationsResult.vue?vue&type=script&lang=js"
export * from "./ClosestPopulationsResult.vue?vue&type=script&lang=js"
import style0 from "./ClosestPopulationsResult.vue?vue&type=style&index=0&id=8476c15c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8476c15c",
  null
  
)

export default component.exports